import { render, staticRenderFns } from "./VerifyIdentity.vue?vue&type=template&id=a4bace00&scoped=true"
import script from "./VerifyIdentity.vue?vue&type=script&lang=js"
export * from "./VerifyIdentity.vue?vue&type=script&lang=js"
import style0 from "./VerifyIdentity.vue?vue&type=style&index=0&id=a4bace00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bace00",
  null
  
)

export default component.exports